// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__E6h1A","select":"Header_select__1BOv1","clinic":"Header_clinic__1OwmC"};